import React from "react";
import { Route, Routes } from "react-router-dom";
import FormSimulation from "./FormSimulation/FormSimulation";
import ListSimulation from "./ListSimulation/ListSimulation";

const Simulation = () => {
  return (
    <div className="simulation">
      <Routes>
        <Route path="/" exact element={<ListSimulation />} />
        <Route path="/new" exact element={<FormSimulation />} />
        <Route path="/*" exact element={<div>Erreur</div>} />
      </Routes>
    </div>
  );
};

export default Simulation;
